module.exports = __webpack_public_path__ + "static/robotic-690ed67c23dbd286236503e522882e73.svg";